import {useQuery} from "@tanstack/react-query";
import {DropsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

/**
 * The rosters this creator is official for.
 *
 * The reverse of `useGetDropRoster`: that reads a publisher's creators, this
 * reads a creator's publishers. Derived server-side from the same
 * `featuredStreams[].dropId` pointer, so nothing is configured per creator — a
 * roster add shows up here on the next read.
 *
 * Long `staleTime` and no polling on purpose. Roster membership is a contract
 * that changes a few times a year, not a live signal; refetching it on the
 * cadence the live-status hooks use would be pure noise.
 *
 * Cast through `any` for the same reason `useGetDropRoster` does — the endpoint
 * is newer than the checked-in client. It goes at the next regen.
 */
export function useGetDropOfficialFor(slug?: string) {
    return useQuery({
        queryKey: ["drop-official-for", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugOfficialFor({slug});
        },
        enabled: Boolean(slug),
        staleTime: 10 * 60 * 1000,
    });
}
